import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/img/icon-arrow-right-active.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "panel" }
const _hoisted_3 = { class: "toolbar-container" }
const _hoisted_4 = { class: "toolbar" }
const _hoisted_5 = { class: "mobile-filter" }
const _hoisted_6 = { class: "desktop-filter" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "dropdown-row" }
const _hoisted_10 = ["colspan"]
const _hoisted_11 = { class: "table-dropdown" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ButtonBar = _resolveComponent("ButtonBar")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_ListMenu = _resolveComponent("ListMenu")!
  const _component_Search = _resolveComponent("Search")!
  const _component_FilterMenu = _resolveComponent("FilterMenu")!
  const _component_MobileSideMenu = _resolveComponent("MobileSideMenu")!
  const _component_TableCell = _resolveComponent("TableCell")!
  const _component_TableDropdown = _resolveComponent("TableDropdown")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_authenticated_layout = _resolveComponent("authenticated-layout")!

  return (_openBlock(), _createBlock(_component_authenticated_layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_Modal, {
          modelValue: false,
          title: _ctx.warning.title,
          onCloseWarning: _ctx.closeWarning
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_ctx.globalModal.body), 1)
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_Button, { text: "Cancel" }),
            _createVNode(_component_Button, { text: "Confirm" })
          ]),
          _: 1
        }, 8, ["title", "onCloseWarning"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_ButtonBar, {
                    onToggleSort: _ctx.toggleSort,
                    onToggleFilter: _ctx.toggleFilter,
                    onOpenSearch: _ctx.openSearch
                  }, null, 8, ["onToggleSort", "onToggleFilter", "onOpenSearch"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args))),
                    class: _normalizeClass({ open: _ctx.buttonBarData.filterOpen })
                  }, [
                    _createVNode(_component_TranslatedText, { path: "filter.title" })
                  ], 2)
                ]),
                _createVNode(_component_ListMenu, {
                  menuItems: _ctx.mobileSortItems,
                  show: _ctx.buttonBarData.sortOpen,
                  onClickMenuItem: _ctx.handleClickSort,
                  onToggleMenu: _ctx.toggleSort
                }, null, 8, ["menuItems", "show", "onClickMenuItem", "onToggleMenu"]),
                _createVNode(_component_Search, {
                  id: 'search-bar',
                  searchOpen: _ctx.buttonBarData.searchOpen,
                  onCloseSearch: _ctx.closeSearch,
                  onFilterSearch: _ctx.filterSearch,
                  class: "style-standard h-pad"
                }, null, 8, ["searchOpen", "onCloseSearch", "onFilterSearch"])
              ])
            ])
          ]),
          (_ctx.buttonBarData.filterOpen)
            ? (_openBlock(), _createBlock(_component_FilterMenu, {
                key: 0,
                filters: _ctx.filters,
                onSelectAll: _ctx.selectAll,
                onToggleChip: _ctx.toggleChip,
                onSelectFilter: _ctx.selectFilter,
                onClearAllFilters: _ctx.clearAllFilters
              }, null, 8, ["filters", "onSelectAll", "onToggleChip", "onSelectFilter", "onClearAllFilters"]))
            : _createCommentVNode("", true),
          (_ctx.buttonBarData.filterOpen)
            ? (_openBlock(), _createBlock(_component_MobileSideMenu, {
                key: 1,
                sideMenu: _ctx.sideMenuItems,
                menuTitle: _ctx.filterTitle,
                inSubmenu: _ctx.inSubmenu,
                onSelectFilter: _ctx.selectFilter,
                onCloseFilters: _ctx.toggleFilter,
                onClickMenuItem: _ctx.clickFilterItem,
                onGoBack: _ctx.goBack
              }, null, 8, ["sideMenu", "menuTitle", "inSubmenu", "onSelectFilter", "onCloseFilters", "onClickMenuItem", "onGoBack"]))
            : _createCommentVNode("", true),
          _createVNode(_component_TableList, {
            tableName: "reviews",
            totalRows: _ctx.totalUsers,
            customClass: _ctx.tableCustomClass,
            selectedRows: _ctx.selectedUserCheckboxes,
            deselectedRows: _ctx.deselectedUserCheckboxes,
            selectAllActive: _ctx.selectAllUsers,
            currentPage: _ctx.currentPage,
            actionsChip: _ctx.userActionsChip,
            paginated: "",
            onChangePage: _ctx.changePage,
            onChangeRowCount: _ctx.changeRowCount,
            onHeadingClick: _ctx.handleClickSort,
            onClearSelection: _ctx.clearTableSelection,
            onToggleActionsChip: _ctx.toggleActionsChip
          }, {
            colspan: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("colgroup", { class: "desktop-cols" }, [
                _createElementVNode("col", { style: {"width":"5%"} }),
                _createElementVNode("col", { style: {"width":"5%"} }),
                _createElementVNode("col", { style: {"width":"18%"} })
              ], -1),
              _createElementVNode("colgroup", { class: "mobile-cols" }, [
                _createElementVNode("col", { style: {"width":"0%"} }),
                _createElementVNode("col", { style: {"width":"10%"} }),
                _createElementVNode("col", { style: {"width":"85%"} }),
                _createElementVNode("col", { style: {"width":"0%"} }),
                _createElementVNode("col", { style: {"width":"0%"} }),
                _createElementVNode("col", { style: {"width":"0%"} }),
                _createElementVNode("col", { style: {"width":"0%"} }),
                _createElementVNode("col", { style: {"width":"0%"} }),
                _createElementVNode("col", { style: {"width":"0%"} }),
                _createElementVNode("col", { style: {"width":"5%"} })
              ], -1)
            ]))]),
            head: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", {
                  class: _normalizeClass({ hidden: _ctx.selectedUserCheckboxes.length })
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desktopHeadings, (heading) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: heading.id,
                      class: _normalizeClass(["sort", [
                    heading.mobileFeatured ? 'primary' : 'secondary',
                    {
                      sortable: heading.sortable,
                      asc: heading.sortable && heading.sortOrder === 'asc',
                      desc: heading.sortable && heading.sortOrder === 'desc',
                      checkbox: heading.dataType === 'checkbox',
                      narrow: !heading.title,
                      center: heading.center,
                    },
                  ]]),
                      onClick: ($event: any) => (
                    heading.sortable
                      ? _ctx.handleClickSort({
                          title: heading.title,
                          id: heading.id,
                        })
                      : null
                  )
                    }, [
                      _createVNode(_component_TranslatedText, {
                        path: heading.title
                      }, null, 8, ["path"])
                    ], 10, _hoisted_7))
                  }), 128))
                ], 2)
              ])
            ]),
            body: _withCtx(() => [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userData, (row, i) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: row.id
                  }, [
                    _createElementVNode("tr", {
                      class: _normalizeClass(["row", {
                    alternate: _ctx.isOdd(i),
                    deactivated: row.deactivated,
                    active: _ctx.headingsData.rowActiveUser === row.rowId,
                    selected:
                      _ctx.selectedUserCheckboxes.includes(row.id) &&
                      !_ctx.deselectedUserCheckboxes.includes(row.id),
                  }])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cols, (col) => {
                        return (_openBlock(), _createBlock(_component_TableCell, {
                          class: _normalizeClass([
                      _ctx.desktopHeadings[col.id]?.mobileFeatured
                        ? 'primary'
                        : 'secondary',
                      { narrow: !_ctx.desktopHeadings[col.id]?.title },
                    ]),
                          rowActive: 
                      _ctx.selectedUserCheckboxes.includes(row.id) &&
                      !_ctx.deselectedUserCheckboxes.includes(row.id)
                        ? true
                        : false
                    ,
                          dataType: col.dataType,
                          data: col.data,
                          key: col.id,
                          onClickCell: ($event: any) => (_ctx.handleClickCell(row.id, row.rowId)),
                          onClickRow: ($event: any) => (_ctx.handleClickRow(row.rowId)),
                          onToggleCheckbox: ($event: any) => (_ctx.toggleCheckbox(row.id))
                        }, null, 8, ["class", "rowActive", "dataType", "data", "onClickCell", "onClickRow", "onToggleCheckbox"]))
                      }), 128)),
                      _createElementVNode("td", {
                        class: "td-button",
                        onClick: ($event: any) => (_ctx.handleClickCell(row.id, row.rowId))
                      }, [...(_cache[2] || (_cache[2] = [
                        _createElementVNode("button", null, [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "",
                            style: {"height":"14px","width":"7px"}
                          })
                        ], -1)
                      ]))], 8, _hoisted_8)
                    ], 2),
                    (_ctx.headingsData.rowActiveUser === i)
                      ? (_openBlock(), _createBlock(_component_TableDropdown, { key: 0 }, {
                          wrapper: _withCtx(() => [
                            _createElementVNode("tr", _hoisted_9, [
                              _createElementVNode("td", {
                                colspan: row.cols.length
                              }, [
                                _createElementVNode("table", _hoisted_11, [
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cols, (col) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: col.id
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desktopHeadings, (heading) => {
                                          return (_openBlock(), _createElementBlock("th", {
                                            key: heading.id,
                                            class: _normalizeClass(["dropdown-heading", [
                                  {
                                    show:
                                      !heading.mobileFeatured &&
                                      col.colId === heading.id &&
                                      !heading.notShownInMobile,
                                  },
                                ]])
                                          }, [
                                            _createElementVNode("span", null, _toDisplayString(heading.title), 1)
                                          ], 2))
                                        }), 128)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desktopHeadings, (heading) => {
                                          return (_openBlock(), _createElementBlock("td", {
                                            key: heading.id,
                                            class: _normalizeClass(["dropdown-value", [
                                  {
                                    show:
                                      !heading.mobileFeatured &&
                                      col.colId === heading.id &&
                                      !heading.notShownInMobile,
                                  },
                                ]])
                                          }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.data, (item, index) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
                                                item
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                                      _createTextVNode(_toDisplayString(item), 1),
                                                      (
                                        col.data.length > 1 &&
                                        index < col.data.length - 1
                                      )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, ", "))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_14, "-"))
                                              ], 64))
                                            }), 128))
                                          ], 2))
                                        }), 128))
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.navigateToUser(row.id))
                                }, " View Review ", 8, _hoisted_15)
                              ], 8, _hoisted_10)
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["totalRows", "customClass", "selectedRows", "deselectedRows", "selectAllActive", "currentPage", "actionsChip", "onChangePage", "onChangeRowCount", "onHeadingClick", "onClearSelection", "onToggleActionsChip"])
        ])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "padding-container" }, null, -1))
    ]),
    _: 1
  }))
}